import api from './api'

export const quizService = {
  // Get quiz questions for a module
  getQuestions: async (moduleId) => {
    const response = await api.get(`/modules/${moduleId}/quiz/questions`)
    return response.data
  },

  // Start a new quiz attempt
  startAttempt: async (moduleId) => {
    const response = await api.post(`/modules/${moduleId}/quiz/start`)
    return response.data
  },

  // Submit an answer
  submitAnswer: async (attemptId, questionId, answer) => {
    const response = await api.post(`/quiz-attempts/${attemptId}/answer`, {
      quiz_question_id: questionId,
      user_answer: answer,
    })
    return response.data
  },

  // Complete quiz attempt
  completeAttempt: async (attemptId) => {
    const response = await api.post(`/quiz-attempts/${attemptId}/complete`)
    return response.data
  },

  // Get quiz results
  getResults: async (attemptId) => {
    const response = await api.get(`/quiz-attempts/${attemptId}/results`)
    return response.data
  },

  // Get user's quiz attempts
  getUserAttempts: async (moduleId) => {
    const response = await api.get(`/modules/${moduleId}/quiz/attempts`)
    return response.data
  },
}
